import localFont from 'next/font/local'

/**
 * Omnyqra brand faces (UI-Kit 4.0, Omnyqra/sim#14), self-hosted from the kit's
 * OFL files (licenses next to the fonts). No request leaves the instance.
 *
 * Instrument Sans is the document face. It takes over Sim's `--font-season`
 * variable instead of introducing a new one, so every `font-season` utility and
 * `--font-season` reference in Sim's components follows without a diff.
 * `display: 'block'` for the same reason Sim's Season config gives: a swap of
 * the document face re-wraps text.
 */
const instrumentSans = localFont({
  src: [
    { path: './InstrumentSans-Regular.woff2', weight: '400', style: 'normal' },
    { path: './InstrumentSans-Medium.woff2', weight: '500', style: 'normal' },
    { path: './InstrumentSans-SemiBold.woff2', weight: '600', style: 'normal' },
    { path: './InstrumentSans-Bold.woff2', weight: '700', style: 'normal' },
  ],
  display: 'block',
  preload: true,
  variable: '--font-season',
  fallback: ['system-ui', 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'Noto Sans'],
  adjustFontFallback: 'Arial',
})

/** Display face for headings (`app/_styles/omnyqra.css`). */
const manrope = localFont({
  src: [
    { path: './Manrope-Regular.woff2', weight: '400', style: 'normal' },
    { path: './Manrope-SemiBold.woff2', weight: '600', style: 'normal' },
    { path: './Manrope-Bold.woff2', weight: '700', style: 'normal' },
    { path: './Manrope-ExtraBold.woff2', weight: '800', style: 'normal' },
  ],
  display: 'swap',
  preload: false,
  variable: '--font-display',
  fallback: ['Arial', 'sans-serif'],
})

/** Metadata and code face. Sim's `--font-mono` stack already reads `--font-martian-mono`. */
const splineSansMono = localFont({
  src: [
    { path: './SplineSansMono-Regular.woff2', weight: '400', style: 'normal' },
    { path: './SplineSansMono-Medium.woff2', weight: '500', style: 'normal' },
  ],
  display: 'swap',
  preload: false,
  variable: '--font-martian-mono',
  fallback: ['ui-monospace', 'Consolas', 'monospace'],
})

/** Class names that define all three font variables; set on `<body>`. */
export const omnyqraFontVariables = [instrumentSans, manrope, splineSansMono]
  .map((font) => font.variable)
  .join(' ')
